import Client from './Client';

export default class TestClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取试题列表
   */
  async listPage(data) {
    const res = await this.client.post('/api/question/listPage', data);
    return res;
  }

  /**
   * 课程章节选择
   */
  async listCourseQuestionSelect() {
    const res = await this.client.post('/api/question/listCourseQuestionSelect');
    return res;
  }

  /**
   * 设置显示/隐藏
   *
   */
  async updateIsShow(data) {
    const res = await this.client.post('/api/question/updateIsShow', data);
    return res;
  }

  /**
   * 删除
   */
  async deleteById(data) {
    const res = await this.client.post('/api/question/deleteById', data);
    return res;
  }

  /**
   * 导出
   */
  async listExcelExport(data) {
    const res = await this.client.get('/api/question/listExcelExport', data);
    return res;
  }

  /**
   * 模板下载
   */
  async listExample() {
    const res = await this.client.post('/api/question/listExample');
    return res;
  }

  /**
   * 导入
   */
  async importExcel(data) {
    const res = await this.client.post('/api/question/importExcel', data);
    return res;
  }
}